import { apiGetThreads, getAIContext } from "api/ai/ai.service";
import { useState, useEffect } from "react";
import { VStack, Button } from "@chakra-ui/react";
import { formatDate } from "utils";
import { Card } from "components/Card";
import { truncate } from "lodash";

export default function AIChatHistoryPanel({ setPanel, setThreadId }) {
  const [threads, setThreads] = useState([]);
  const context = getAIContext();
  console.log("context", context);
  useEffect(() => {
    apiGetThreads({ questionId: context.questionId }).then((data) => {
      console.log("get threads data", data);
      setThreads(data);
    });
  }, [context.questionId]);

  const handlePickThread = (threadId) => {
    setThreadId(threadId);
    setPanel("chat");
  };

  return (
    <div>
      AIChatHistoryPanel
      <VStack>
        {threads.map((thread) => (
          <Card key={thread.id} onClick={(e) => handlePickThread(thread.id)} p={2} cursor="pointer">
            {formatDate(thread.created_date)} {truncate(thread.messages?.[0]?.content, 280)}
            <br />
            ... {thread.messages?.length || 0} messages
            <br />
            <small>Thread: {thread.id}</small>
          </Card>
        ))}
      </VStack>
    </div>
  );
}
